import React, { useState, useEffect } from "react";
import classes from './Sale.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, Edit, Trash } from 'lucide-react';
import { Pencil, Trash2, Printer } from 'lucide-react';
import pos from "../../Assets/poss.png";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import api, { BASE_URL, withCompanyId } from "../../Components/API/Api";
import Swal from 'sweetalert2';


const Sale = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [invoiceItems, setInvoiceItems] = useState([]);

    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // ✅ Move these here, outside useEffect:
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [selectMetrics, setSelectedMetrics] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        office_address: ''
    });
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const totalTransactions = customers.reduce((acc, customer) => {
        return acc + (customer.ledgers?.length || 0);
    }, 0);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            const token = localStorage.getItem("authToken");

            const payload = {
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                address: formData.address,
                office_address: formData.office_address,
            };

            console.log("Sending Payload:", payload);
            console.log("Token:", token);

            const response = await api.post(
                '/v1/customer/add',
                withCompanyId(payload)
            );

            // Add new customer to list
            setCustomers((prev) => [...prev, response.data.data]);

            // Reset form
            setFormData({
                name: "",
                email: "",
                phone: "",
                address: "",
                office_address: "",
            });

            setIsModalOpen(false);

            Swal.fire({
                icon: "success",
                title: "Customer Added",
                text: response.data.message || 'Customer added!',
                timer: 2000,
                showConfirmButton: false,
            });

        } catch (error) {
            console.log("❌ Error Keys:", Object.keys(error.response?.data || {}));

            const errorMessage =
                typeof error.response?.data?.message === "object"
                    ? Object.values(error.response.data.message).flat().join("\n")
                    : error.response?.data?.message || "Something went wrong.";

            Swal.fire({
                icon: "error",
                title: "Failed to Add Customer",
                text: errorMessage,
            });
        } finally {
            setSubmitting(false);
        }
    };


    const totalBalance = customers.reduce((acc, customer) => {
        return acc + Number(customer.balance || 0);
    }, 0);

    useEffect(() => {


        const fetchMetrics = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await api.get('/v1/metrics/sales-pos-metrics');
                if (res.data && res.data.status && res.data.data) {
                    // Remove Array.isArray check since data is an object
                    setSelectedMetrics(res.data.data);
                }
            } catch (err) {
                setSelectedMetrics(null);
            }
        };
        fetchMetrics();
    }, []);
    useEffect(() => {
        const authToken = localStorage.getItem('authToken');

        if (!authToken) {
            setError("Authorization token not found.");
            navigate('/signin');
            return;
        }

        const fetchCustomers = async () => {
            try {
                const res = await api.get('/v1/customer');
                const customerData = res.data?.data?.data || res.data?.data || [];
                setCustomers(customerData);
            } catch (err) {
                console.error("Error fetching customers:", err?.response?.data || err.message);
                setError(err.response?.data?.message || "Failed to fetch customers. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        fetchCustomers();
    }, [navigate]);








    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const renderSkeletonRows = () =>
        [...Array(6)].map((_, i) => (
            <tr key={i} className={classes.tableRow}>
                {Array.from({ length: 7 }).map((__, j) => (
                    <td key={j} className={classes.tableCell}>
                        <div className={classes.skeletonBox}></div>
                    </td>
                ))}
            </tr>
        ));
    const InvoiceModal = ({ show, onClose, invoice }) => {
        if (!show) return null;

        return (
            <div className={classes.modalOverlay}>
                <div className={classes.modalContent}>
                    <div className={classes.modalHeader}>
                        <h3>Invoice Preview</h3>
                        <button className={classes.closeBtn} onClick={onClose}>×</button>
                    </div>

                    <div className={classes.modalBody}>
                        <div className={classes.invoiceInfo}>
                            <p><strong>Invoice Number:</strong> {invoice.invoice_number}</p>
                            <p><strong>Transaction Date:</strong> {invoice.transaction_date}</p>
                            <p><strong>Amount Sold:</strong> ₦{Number(invoice.amount || invoice.total).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</p>
                        </div>

                        <table className={classes.modalTable}>
                            <thead>
                                <tr>
                                    <th>Items</th>
                                    <th>Qty</th>
                                    <th>Item Amount</th>
                                    <th>Discount</th>
                                    <th>Discount Amount</th>
                                    <th>Vat</th>
                                    <th>Wht</th>
                                    <th>Total</th>
                                </tr>
                            </thead>

                            <tbody>
                                {invoice.sales?.length > 0 ? invoice.sales.map((item, idx) => {
                                    const amount = Number(item.amount || 0);
                                    const discountPercent = Number(item.discount_percentage || 0);
                                    const discountAmount = (amount * discountPercent) / 100;
                                    const discountedAmount = amount - discountAmount;
                                    const taxRates = { 1: 7.5 };
                                    const whtRates = { 2: 2 };
                                    const vatAmount = discountedAmount * (taxRates[item.tax_id] || 0) / 100;
                                    const whtAmount = discountedAmount * (whtRates[item.wht_id] || 0) / 100;
                                    const totalAmount = discountedAmount + vatAmount + whtAmount;

                                    return (
                                        <tr key={idx}>
                                            <td>{item.item?.name || "—"}</td>
                                            <td className={classes.moneyCell}>{item.quantity || 0}</td>
                                            <td className={classes.moneyCell}>₦{amount.toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                                            <td className={classes.moneyCell}>{discountPercent ? `${discountPercent}%` : '0%'}</td>
                                            <td className={classes.moneyCell}>₦{discountAmount.toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                                            <td className={classes.moneyCell}>₦{vatAmount.toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                                            <td className={classes.moneyCell}>{whtAmount.toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                                            <td className={classes.moneyCell}>{totalAmount.toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                                        </tr>
                                    );
                                }) : (
                                    <tr>
                                        <td colSpan={8} style={{ textAlign: "center", padding: "10px" }}>
                                            No items found
                                        </td>
                                    </tr>
                                )}
                            </tbody>



                        </table>
                        <div className={classes.invoiceInfos}>
                            <p><strong>Total Amount:</strong> ₦{Number(invoice.amount || invoice.total).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };




    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const response = await api.get('/v1/fetch-sales');
                setInvoiceItems(response.data?.data);
                console.log(response.data)
            } catch (error) {
                console.error("Failed to fetch invoices:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchInvoices();
    }, []);

    const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);

    const openInvoiceModal = (invoice) => {
        setSelectedInvoice(invoice);
        setIsInvoiceModalOpen(true);
    };

    const closeInvoiceModal = () => {
        setSelectedInvoice(null);
        setIsInvoiceModalOpen(false);
    };



    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Sales</h2>
                    <h1 className={classes.Titles}>
                        Manage your sales transactions, invoices, and customer payments.
                    </h1>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total sales</p>
                                <p className={classes.kdptg1}>{selectMetrics?.total_receipt?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Overdue</p>
                                <p className={classes.kdptg3}>{selectMetrics?.total_amount?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Past due dates</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Outstanding</p>
                                <p className={classes.kdptg2}>{selectMetrics?.outstanding?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Pending payments</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                            <input type="text" className={classes.searchBar} placeholder="Search all entries" />
                        </div>
                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All Methods</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>
                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBars} placeholder="Filter..." />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>
                    <div className={classes.btnsMain}>
                        <button
                            className={classes.btnss}
                            onClick={() => navigate("/transactions/sales-pos/makesale")}
                        >
                            + New Sales
                        </button>
                    </div>
                </div>

                <div className={classes.invoicecont}>
                    <table className={classes.invoiceTable}>
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Transaction Date</th>
                                <th>Invoice Number</th>
                                <th>Customer</th>
                                <th>Description</th>
                                <th>Total Amount</th>
                                <th>Total Paid</th>
                                <th>Balance</th>
                                <th>Status</th>
                                <th>Post Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                [...Array(5)].map((_, i) => (
                                    <tr key={i}>
                                        {[...Array(11)].map((__, j) => (
                                            <td key={j}><div className={classes.skeleton}></div></td>
                                        ))}
                                    </tr>
                                ))
                            ) : invoiceItems.length === 0 ? (
                                <tr>
                                    <td colSpan="11" style={{ textAlign: 'center', padding: '20px' }}>
                                        No sales invoices found.
                                    </td>
                                </tr>
                            ) : (
                                invoiceItems.map((item, index) => (
                                    <tr key={item.id || index}>
                                        <td>{index + 1}</td>
                                        <td>{item.transaction_date}</td>
                                        <td>
                                            <span
                                                className={classes.clickableInvoice}
                                                onClick={() => openInvoiceModal(item)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                {item.invoice_number}
                                            </span>
                                        </td>

                                        <td>
                                            <span className={classes.truncateName}>
                                                {item?.customer?.name || item.customer_id}
                                            </span>
                                        </td>


                                        <td>{item.description}</td>
                                        <td style={{ textAlign: 'right' }}>{Number(item.amount || 0).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                                        <td style={{ textAlign: 'right' }}>{Number(item.credit || 0).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>
                                        <td style={{ textAlign: 'right' }}>{Number(item.debit || 0).toLocaleString('en-NG', { minimumFractionDigits: 2 })}</td>

                                        <td>
                                            <span
                                                className={
                                                    Number(item.debit) === 0
                                                        ? classes.statusPaid
                                                        : Number(item.debit) === Number(item.amount)
                                                            ? classes.statusPending
                                                            : Number(item.debit) < Number(item.amount)
                                                                ? classes.statusPartPayment
                                                                : classes.statusPending
                                                }
                                            >
                                                {Number(item.debit) === 0
                                                    ? "Paid"
                                                    : Number(item.debit) === Number(item.amount)
                                                        ? "Pending"
                                                        : Number(item.debit) < Number(item.amount)
                                                            ? "Paid Part"
                                                            : "Pending"}
                                            </span>

                                        </td>
                                        <td>{item.created_at?.split("T")[0] || "—"}</td>
                                        <td className={classes.actionsIcons}>

                                            <div onClick={() =>
                                                navigate('/print_sales_recepits', { state: { invoice: item } })
                                            }>
                                                <img src={pos} style={{ width: 20, height: 20, margin: "0 6px", cursor: "pointer" }} />
                                            </div>

                                            <span
                                                onClick={() =>
                                                    navigate('/printreceipts', { state: { invoice: item } })
                                                }
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <Printer size={16} style={{ color: 'rgb(37, 99, 235)' }} />
                                            </span>
                                            <Trash2 size={16} style={{ color: 'rgb(255, 2, 2)', margin: '0 6px' }} />


                                        </td>

                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    <div className={classes.paginationContainer}>
                        <div className={classes.paginationControls}>
                            <button>First</button>
                            <button className={classes.active}>1</button>
                            <button>2</button>
                            <button>Last</button>
                            <span className={classes.pageText}>
                                Displaying 1 - {invoiceItems.length} of {invoiceItems.length}
                            </span>
                        </div>
                    </div>
                </div>

                {/* <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.page}>2</td>
                            <td>Last</td>
                        </tr>
                        <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>
                    </tfoot>
                </table> */}
            </div>

            <Footer />

            {isModalOpen && (
                <div className={classes.modalBackdrop}>
                    <div className={classes.modal}>
                        <h2>Add New Customer</h2>

                        {/* Scrollable Form Container */}
                        <div className={classes.scrollContainer}>
                            <form className={classes.modalForm} onSubmit={handleSubmit}>
                                <label>Customer Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Enter Customer Name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />

                                <label>Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Enter Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />

                                <label>Phone Number</label>
                                <input
                                    type="text"
                                    name="phone"
                                    placeholder="Enter Phone Number"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />

                                <label>Customer's Address</label>
                                <input
                                    type="text"
                                    name="address"
                                    placeholder="Enter Customer's Address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    required
                                />

                                <label>Customer's Office Address</label>
                                <input
                                    type="text"
                                    name="office_address"
                                    placeholder="Enter Customer's Office Address"
                                    value={formData.office_address}
                                    onChange={handleChange}
                                    required
                                />

                                <div className={classes.modalActions}>
                                    <button type="submit" className={classes.btnss} disabled={submitting}>
                                        {submitting ? 'Adding...' : 'Add Customer'}
                                    </button>
                                    <button
                                        type="button"
                                        className={classes.btnssWhite}
                                        onClick={() => setIsModalOpen(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            )}

            {selectedInvoice && (
                <InvoiceModal
                    show={true}  // always true if selectedInvoice exists
                    onClose={closeInvoiceModal}
                    invoice={selectedInvoice}
                />
            )}



        </div>
    );
};

export default Sale;
